import apiService from './api';

class StudyPlannerService {
  constructor() {
    this.baseURL = '/api/v1/study-planner';
  }

  /**
   * Analyze uploaded exam schedule document
   */
  async analyzeDocument(file) {
    try {
      console.log('🔄 StudyPlannerService: Analyzing document...', file.name);
      
      const formData = new FormData();
      formData.append('file', file);

      const response = await apiService.request({
        method: 'POST',
        url: `${this.baseURL}/analyze-document`,
        body: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('✅ StudyPlannerService: Document analyzed successfully');
      return response;
    } catch (error) {
      console.error('❌ StudyPlannerService: Error analyzing document:', error);
      throw error;
    }
  }

  /**
   * Chat with the study planner AI
   */
  async chat(message, context = null) {
    try {
      console.log('🔄 StudyPlannerService: Sending chat message...', message);
      
      const formData = new FormData();
      formData.append('message', message);
      if (context) {
        formData.append('context', context);
      }

      const response = await apiService.request({
        method: 'POST',
        url: `${this.baseURL}/chat`,
        body: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('✅ StudyPlannerService: Chat response received');
      return response;
    } catch (error) {
      console.error('❌ StudyPlannerService: Error in chat:', error);
      throw error;
    }
  }

  /**
   * Create a personalized study plan
   */
  async createStudyPlan(examInfo, userRoutine) {
    try {
      console.log('🔄 StudyPlannerService: Creating study plan...', { examInfo, userRoutine });
      
      const response = await apiService.request({
        method: 'POST',
        url: `${this.baseURL}/create-study-plan`,
        body: JSON.stringify({
          exam_info: examInfo,
          user_routine: userRoutine
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('✅ StudyPlannerService: Study plan created successfully');
      return response;
    } catch (error) {
      console.error('❌ StudyPlannerService: Error creating study plan:', error);
      throw error;
    }
  }

  /**
   * Health check for study planner service
   */
  async healthCheck() {
    try {
      const response = await apiService.request({
        method: 'GET',
        url: `${this.baseURL}/health`,
      });
      return response;
    } catch (error) {
      console.error('❌ StudyPlannerService: Health check failed:', error);
      throw error;
    }
  }

  /**
   * Validate if a message is academic-related
   */
  isAcademicMessage(message) {
    const academicKeywords = [
      'study', 'exam', 'test', 'assignment', 'homework', 'project', 'schedule', 
      'plan', 'routine', 'subject', 'course', 'class', 'revision', 'preparation',
      'time', 'organize', 'priority', 'goal', 'deadline', 'due', 'academic',
      'learn', 'practice', 'review', 'notes', 'book', 'chapter', 'topic'
    ];
    
    const messageLower = message.toLowerCase();
    return academicKeywords.some(keyword => messageLower.includes(keyword));
  }

  /**
   * Format error messages for user display
   */
  formatErrorMessage(error) {
    if (error.response?.data?.detail) {
      return error.response.data.detail;
    }
    if (error.message) {
      return error.message;
    }
    return 'An unexpected error occurred. Please try again.';
  }
}

export default new StudyPlannerService(); 